import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@ngneat/transloco';
import { Store } from '@ngrx/store';

import { CancelProcessInstance } from '../../store/actions';

@Component({
    selector: 'app-bulkdeleteactiondialog',
    templateUrl: './bulkdeleteactiondialog.component.html',
    styleUrls: ['./bulkdeleteactiondialog.component.scss'],
    standalone: false,
})
export class BulkDeleteActionDialog implements OnInit {
    public deleteRecords: any;
    public records: any;
    public assetDataId: string;
    public isSingleRecord: boolean;
    public action: any;
    public restApiName: string;
    public isValidProcessId = false;
    public cancelProcessComment: string;
    public processId: string;
    public errors = {
        processIdError: [],
    };
    public isValidDescription = false;

    constructor(private dialog: MatDialog, private store$: Store) {}

    closeModal = () => {
        this.isValidProcessId = false;
        this.isValidDescription = false;
        this.processId = '';
        this.cancelProcessComment = '';
        this.errors.processIdError = [];
        this.dialog.closeAll();
    };

    public checkDescriptionComment = comment => {
        this.isValidDescription = comment?.length > 0 ? true : false;
    };

    public checkProcessId = (processId: string): void => {
        const lastEightDigitsOfInstanceId = this.assetDataId.slice(-8);
        if (lastEightDigitsOfInstanceId === processId) {
            this.isValidProcessId = true;
            this.errors.processIdError = [];
        } else {
            this.isValidProcessId = false;
            this.errors.processIdError.push(
                translate('The entered code does not match the last 8 digits of the Process ID. Please try again.')
            );
        }
    };

    cancelInstance = () => {
        this.store$.dispatch(
            CancelProcessInstance({
                instanceId: this.assetDataId,
                comment: this.cancelProcessComment,
                restApiName: this.restApiName,
            })
        );
        this.closeModal();
    };

    ngOnInit() {}
}
